"use strict";
'app public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vue = require("vue");
var _state = _interopRequireDefault(require("@/libs/state"));
var _UserAvatarCommon = require("./UserAvatarCommon");
var _default = exports.default = {
  __name: 'UserAvatar',
  props: {
    user: {
      type: Object,
      default: null
    },
    message: {
      type: Object,
      default: null
    },
    network: {
      type: Object,
      default: null
    },
    size: {
      type: String,
      default: 'small'
    },
    forceShowStatus: {
      type: Boolean,
      default: false
    },
    hideStatus: {
      type: Boolean,
      default: false
    },
    allowToggle: {
      type: Boolean,
      default: false
    },
    // Salon d'où provient l'avatar. Fournit une source de présence RÉACTIVE
    // (buffer.users) pour que l'avatar d'un message se mette à jour au quit/retour.
    buffer: {
      type: Object,
      default: null
    }
  },
  setup(__props) {
    const props = __props;
    const state = (0, _state.default)();
    const getSizeObj = size => ({
      url: props.user.avatar[size],
      vbind: {
        'href': props.user.avatar[size],
        'xlink:href': props.user.avatar[size]
      },
      setFailed: () => {
        const avatar = props.user.avatar;
        const failedAvatar = avatar[size];
        avatar[size] = '';
        if (!avatar.small && !avatar.large) {
          state.$emit('user.avatar.failed', {
            user: props.user,
            network: props.network,
            failed: failedAvatar
          });
        }
      }
    });
    const shouldShowStatus = () => {
      if (!props.network || !props.user) {
        return false;
      }
      if (props.hideStatus) {
        return false;
      }
      if (props.forceShowStatus) {
        return true;
      }
      if (props.network.state !== 'connected' || !state.setting('showAwayStatusIndicators')) {
        return false;
      }
      const awayNotifyEnabled = props.network.ircClient.network.cap.isEnabled('away-notify');
      return state.setting('buffers.who_loop') || awayNotifyEnabled;
    };

    // Présence « live » : on résout l'utilisateur dans buffer.users (RÉACTIF) plutôt
    // que de se fier à props.user, souvent une référence FIGÉE (message.user). Au quit
    // cette référence passe à away='offline' ; au retour, un NOUVEL objet user est créé
    // et ajouté à buffer.users, mais le message pointe toujours l'ancien → l'avatar
    // resterait grisé. En lisant buffer.users (add/remove réactifs), l'avatar se met à
    // jour TOUT SEUL : au retour l'objet live (online) reprend la main → couleur +
    // pastille verte ; au quit il sort de buffer.users → repli sur props.user
    // (away='offline') → grisé. NB : network.users est non-réactif (def()), inutilisable.
    const presenceUser = (0, _vue.computed)(() => {
      // En salon : buffer.users (réactif) reflète join/quit.
      const buf = props.buffer;
      if (buf && buf.users && props.user && props.user.nick) {
        const live = buf.users[props.user.nick.toUpperCase()];
        if (live) {
          return live;
        }
      }
      // En privé (buffer.users vide) : on résout via le réseau. network.users est
      // non-réactif → on lit usersRevision pour forcer la ré-évaluation au join/quit.
      if (props.network && props.user && props.user.nick && props.network.userByName) {
        // Lecture de usersRevision → dépendance réactive (ré-évaluation au join/quit).
        // eslint-disable-next-line no-unused-expressions
        props.network.usersRevision;
        const live = props.network.userByName(props.user.nick);
        if (live) {
          return live;
        }
      }
      return props.user;
    });
    const awayStatus = (0, _vue.computed)(() => {
      const show = shouldShowStatus();
      const vbind = {};
      if (show) {
        vbind.mask = 'url(#app-avatar-mask)';
      }
      const transform = (0, _UserAvatarCommon.getAvatarTransform)();
      return {
        show,
        vbind,
        transform
      };
    });
    const avatar = (0, _vue.computed)(() => {
      let initialsLength = state.setting('avatars.initials_length');
      if (!initialsLength || initialsLength < 1) {
        initialsLength = 1;
      }
      if (initialsLength > 2) {
        initialsLength = 2;
      }
      const nick = props.message?.nick || props.user?.nick || 'User';
      const initials = nick.substring(0, initialsLength).toUpperCase();
      const hasImage = !!(props.user && (props.user.avatar.small || props.user.avatar.large));
      const showBackground = !hasImage || state.setting('avatars.show_image_background');
      const backgroundStyle = {};
      const avatars = {
        hasImage,
        initials,
        showBackground,
        backgroundStyle,
        sizeKey: {}
      };
      if (props.user) {
        backgroundStyle.fill = props.user.getColour();
      } else {
        return avatars;
      }
      if (props.user.avatar.small) {
        avatars.small = getSizeObj('small');
        avatars.sizeKey.small = 'small';
        if (!props.user.avatar.large) {
          avatars.sizeKey.large = 'small';
        }
      }
      if (props.user.avatar.large) {
        avatars.large = getSizeObj('large');
        avatars.sizeKey.large = 'large';
        if (!props.user.avatar.small) {
          avatars.sizeKey.small = 'large';
        }
      }
      return avatars;
    });
    const toggleAway = () => {
      if (!props.allowToggle || props.user.away === 'offline') {
        return;
      }
      const isAway = props.user.isAway();
      props.network.ircClient.raw('AWAY', isAway ? '' : 'Absent');
    };
    return {
      __sfc: true,
      state,
      props,
      getSizeObj,
      shouldShowStatus,
      presenceUser,
      awayStatus,
      avatar,
      toggleAway
    };
  }
};
window._app_exports = window._app_exports || {};
if(!window._app_exports["components"]) window._app_exports["components"] = {};
window._app_exports["components"]["UserAvatar"]
window._app_exports.components.UserAvatar = exports.default ? exports.default : exports;
